import { Checkbox as FluentCheckbox } from "@fluentui/web-components";
/**
 * Checkbox
 * @summary A Checkbox Custom HTML Element that implements the ARIA checkbox role with customizable states and indicators.
 *
 * @example
 * ```html
 * <fabric-checkbox
 *    ?checked="${x => x.checked}"
 *    ?disabled="${x => x.disabled}"
 *    ?indeterminate="${x => x.indeterminate}"
 *    shape="${x => x.shape}"
 *    size="${x => x.size}"
 * >
 *    <span slot="checked-indicator">[Checked Indicator]</span>
 *    <span slot="indeterminate-indicator">[Indeterminate Indicator]</span>
 * </fabric-checkbox>
 * ```
 *
 * @attr {boolean | undefined} checked - The initial checked state of the element.
 * @attr {boolean | undefined} disabled - The initial disabled state of the control.
 * @attr {boolean | undefined} indeterminate - Indicates that the element is in an indeterminate or mixed state.
 * @attr {CheckboxShape | undefined} shape - Indicates the shape of the checkbox.
 * @attr {CheckboxSize | undefined} size - Indicates the size of the control.
 * @attr {boolean | undefined} required - Indicates that the element is required.
 * @attr {string | undefined} name - The name of the checkbox.
 * @attr {string | undefined} value - The value of the checkbox.
 *
 * @prop {boolean} indeterminate - Indicates the indeterminate state of the checkbox.
 * @prop {CheckboxShape} shape - Indicates the shape of the checkbox, can be 'circular' or 'square'.
 * @prop {CheckboxSize} size - Indicates the size of the checkbox, can be 'medium' or 'large'.
 *
 * @slot checked-indicator - The checked indicator.
 * @slot indeterminate-indicator - The indeterminate indicator.
 *
 * @csspart checked-indicator - The checked state indicator.
 * @csspart indeterminate-indicator - The indeterminate state indicator.
 *
 * @method toggleChecked - Toggles the checked state of the control.
 *
 * @fires change - Emits a custom change event when the checked state changes.
 * @fires input - Emits a custom input event when the checked state changes.
 *
 * @extends FluentCheckbox
 * @tagname fabric-checkbox
 * @public
 */
export class Checkbox extends FluentCheckbox {
}
//# sourceMappingURL=checkbox.js.map